export default __webpack_public_path__ + "static/media/document_download_icon.28d606ef.svg";